module.exports = __webpack_public_path__ + "static/media/icon-settings.3f0e86fa.svg";